export default __webpack_public_path__ + "static/media/vuex.081fa0e1.svg";